import { getBposNavBarData, getBposNavBarDataAsync } from 'owa-bpos-store/lib/bposNavBarData';
import { isFeatureEnabled } from 'owa-feature-flags';
import { AppAcquisitionLink } from 'owa-graph-schema';
import { getPromiseForLocalizedString } from 'owa-localize';
import { moreApps } from 'owa-locstrings/lib/strings/moreapps.locstring.json';
import {
    APP_STORE_MESSAGE_EXTENSION,
    APP_STORE_LAUNCH_PAGE,
} from 'owa-app-definitions/lib/data/AppStore';

import type NavBarData from 'owa-service/lib/contract/NavBarData';

export function getAcquisitionLinkData(
    isShownInAppBar: boolean,
    displayText: string
): AppAcquisitionLink {
    return {
        __typename: 'AppAcquisitionLink',
        id: isShownInAppBar ? APP_STORE_LAUNCH_PAGE : APP_STORE_MESSAGE_EXTENSION,
        text: displayText,
        accessibleName: 'Get more Microsoft 365 applications',
        icon: {
            name: 'ArrowRightIcon',
        },
        command: {
            entity: {
                entityId: isShownInAppBar ? APP_STORE_LAUNCH_PAGE : APP_STORE_MESSAGE_EXTENSION,
                type: isShownInAppBar ? 'm365_app' : 'm365_messageextension',
                action: 'default',
            },
            command: {
                visibilityState: 'show',
                stateTransition: 'flush',
            },
        },
    };
}

export async function getAcquisitionLink(
    bposNavBarData: NavBarData | null = null,
    isShownInAppBar: boolean = true
): Promise<AppAcquisitionLink[]> {
    if (!isFeatureEnabled('mos-appStore')) {
        return [];
    }

    if (!bposNavBarData) {
        await getBposNavBarDataAsync('getStaticTiles', 'worker', true /* ignore auth error */);
    }
    bposNavBarData = getBposNavBarData();
    const hasTeamsLicense =
        (
            bposNavBarData?.WorkloadLinks?.filter(
                appLink => appLink?.Text?.toLowerCase() === 'teams'
            ) ?? []
        ).length > 0;

    const displayText = await getPromiseForLocalizedString(moreApps);

    return hasTeamsLicense ? [getAcquisitionLinkData(isShownInAppBar, displayText)] : [];
}
